import type { MarketExceptionType } from '../../MarketExceptionTypes'

export const DO: MarketExceptionType = {
  hasNativeCreditCard: true,
  hasStoreCredit: false,
  marketoSmsOptIn: true,
  signUpReCaptcha: true,
  showPasswordRequirements: true,
  signupPrivacyPolicy: {
    enabled: true,
    required: true,
  },
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: true,
    required: true,
  },
  omitSubscriptionsAppWide: false,
  checkoutTermsAndConditionsStatement: false,
  currencyCode: 'USD',
  creditCardProvidersSupported: ['MC', 'VI', 'AX', 'DI'],
  isWorldPay3DS: false,
  poboxRestricted: true,
  isPickupMarket: true,
  hasAddressRegion: false,
  allowShippingToExternalCountries: false,
  supportsStoreCredit: true,
  applePayOTP: false,
  applePaySubscriptions: false,
  hasPaypal: false,
  hasPaypal3DS: false,
  hasShipByDate: false,
  hasProductAvailability: true,
  bankName: 'WorldPay',
  skuPricingOverrides: ['36306'],
  allowSubscriptionPickup: true,
  skuAvailabilityShippingMethod: 'WillCall&location=Unicity DR',
  defaultEconomyShippingMethod: 'Economy',
  hasAddressValidation: false,
  hasZipCode: false,
  isUlabsAvailable: false,
}
